import BaseApi from '@/api/base';
import { ModalType } from '@/constants';
import { UserJob } from '@/types';
import { getImpersonationParams, hideLoader, showLoader } from '@/util';

const setModalType = (response: Window | null) => response === null ? ModalType.POPUP_BLOCKER : response.closed ? ModalType.DOCUMENT_DOWNLOAD : ModalType.DOCUMENT_PREVIEW;

export const downloadFile = async (id: string, fileName: string, type: string, divisionId: string) => {
  showLoader();
  let modalType = '';
  const response = await BaseApi.get(`buyer/document/${divisionId}/${id}`, { params: getImpersonationParams() });
  const r = await fetch(response);
  const blob = await r.blob();
  return new Promise((resolve, reject) => {
    let blobUrl = '';
    if (type === 'PDF') {
      const file = new File([blob], fileName, { type: 'application/pdf' });
      blobUrl = URL.createObjectURL(file);
      const popupResponse = window.open(blobUrl, '_blank');
      const timer = setTimeout(() => {
        modalType = setModalType(popupResponse);
        clearTimeout(timer);
        resolve(modalType);
      }, 1000);
    } else {
      const file = new File([blob], fileName, { type: 'application/octet-stream' });
      blobUrl = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      modalType = ModalType.DOCUMENT_DOWNLOAD;
      resolve(modalType);
    }
    hideLoader();
  })
};

export const getUniqueJobs = (jobList: UserJob[]) => {
  return jobList.reduce((accumulator: UserJob[], current: UserJob) => {
    if (
      !accumulator.some(
        (item) => item.jobNumber === current.jobNumber
      )
    ) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);
}
